// src/api/loginAgreementService.js

import api from "./api";

// Backend controller route: [Route("api/LoginAgreement")]
const API_URL = "/LoginAgreement";

/**
 * Get the latest agreement
 * GET /api/LoginAgreement/latest
 */
export const fetchLatestLoginAgreement = async () =>
    (await api.get(`${API_URL}/latest`)).data;

/**
 * Get all agreements
 * GET /api/LoginAgreement
 */
export const getLoginAgreements = async () =>
    (await api.get(API_URL)).data;

/**
 * Get agreement by id
 * GET /api/LoginAgreement/{id}
 */
export const getLoginAgreement = async (id) =>
    (await api.get(`${API_URL}/${id}`)).data;

/**
 * Create new agreement
 * POST /api/LoginAgreement
 */
export const createLoginAgreement = async (data) =>
    (await api.post(API_URL, data)).data;

/**
 * Update agreement
 * PUT /api/LoginAgreement/{id}
 */
export const updateLoginAgreement = async (id, data) =>
    (await api.put(`${API_URL}/${id}`, data)).data;

/**
 * Delete agreement
 * DELETE /api/LoginAgreement/{id}
 */
export const deleteLoginAgreement = async (id) =>
    (await api.delete(`${API_URL}/${id}`)).data;

export default {
    fetchLatestLoginAgreement,
    getLoginAgreements,
    getLoginAgreement,
    createLoginAgreement,
    updateLoginAgreement,
    deleteLoginAgreement,
};
